export const PERFORM_TASK = "PERFORM_TASK";
export const UPDATE_TASK = "UPDATE_TASK";

export const SYNC_MENU_TASK = "SYNC_MENU_TASK";
